module.exports = __webpack_public_path__ + "fb94d274f6aa161a757469e96a6a39d1.fbx";